import { render, staticRenderFns } from "./OrgTokenFiltering.vue?vue&type=template&id=1a453a56&"
import script from "./OrgTokenFiltering.vue?vue&type=script&lang=js&"
export * from "./OrgTokenFiltering.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports